module.exports = __webpack_public_path__ + "static/img/Widgets.70cc5b97.svg";